import React, {useState, useCallback, useEffect, useRef} from 'react';
import Dropzone, {useDropzone} from 'react-dropzone';
import axios from 'axios';
import Cookies from 'js-cookie';
import {Link, useNavigate, useSearchParams} from 'react-router-dom';
import LinearProgress from '@mui/material/LinearProgress';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {IotDropzoneIcon, DragNDrop} from '../../assets';
import Swal from 'sweetalert2';
import {Box} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Loader} from '../Loader';
import {Language} from '../../context/LanguageContext';
import {useUser} from '../../hooks';
// import word from '../assets/images/word.png';
// import excel from '../assets/images/excel.png';
// import acrobat from '../assets/images/Icon.png';
// import zip from '../assets/images/qgisZip.png';

export default function PengesyoranBajaDropzone({onChange}) {
  const {language, newObj} = Language();
  const [searchParams] = useSearchParams();
  const [progress, setProgress] = useState(0);
  const [steps, setSteps] = useState(0);
  const {uploadSyorGetah, uploadSyorSawit} = useUser();
  const apiUrl = process.env.REACT_APP_MAIN_URL;
  const [payload, setPayload] = useState({
    type: '',
  });
  const token = Cookies.get('token');
  const [file, setFile] = useState();
  const [uploadStatus, setUploadStatus] = useState('Uploading...');
  const tokens_session = Cookies.get('token');
  const lang = useRef(language);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    onChange(steps);
  }, [steps]);

  const uploadFile = async (file) => {
    setSteps(1);
    setFile(file);
  };

  useEffect(() => {
    lang.current = language;
  }, [language]);

  const handleSubmit = useCallback(
    async (file) => {
      let guidValue = null;
      setSteps(2);
      setProgress(0);
      let response;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('lang', lang.current == 1 ? 'en' : 'my');

      let eventSource = new EventSource(
        `${apiUrl}/syor/progress?token=Bearer ${token}`
      );

      eventSource.addEventListener('GUI_ID', async (event) => {
        console.log(`Guid from server: ${guidValue}`);
        // guidValue = JSON.parse(event.data);
        guidValue = event.data.replace(/"/g, '');
        formData.append('guid', guidValue);
        eventSource.addEventListener(guidValue, (event) => {
          const result = JSON.parse(event?.data);
          if (progress !== result.progress) {
            setProgress(result.progress);
          }
          if (uploadStatus !== result?.status) {
            setUploadStatus(result?.status);
          }
          if (result?.status === 'Done!') {
            eventSource.close();
          } else if (result?.status === 'Error!') {
            setProgress(0);
            onChange(0);
            eventSource.close();
          }
        });

        if (payload.type === 'sawit')
          response = await uploadSyorSawit(tokens_session, formData);
        else response = await uploadSyorGetah(tokens_session, formData);

        if (response?.status === 200) setSteps(3);
        else {
          setSteps(0);
          setProgress(0);
          onChange(0);
        }
      });
    },
    [payload, tokens_session, lang.current]
  );

  const onDrop = useCallback(
    (acceptedFiles) => {
      // Handle the dropped files here
      acceptedFiles.forEach((file) => {
        handleSubmit(file);
      });
    },
    [payload, tokens_session, lang.current]
  );
  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    rejectedFiles,
    isDragReject,
  } = useDropzone({
    onDrop,
    multiple: false,
    minSize: 0,
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.ms-excel': ['.xls'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        '.xlsx',
      ],
    },
  });
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      {steps === 1 && (
        <input
          {...getInputProps()}
          style={{
            display: 'block',
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            opacity: '0',
            cursor: 'pointer',
          }}
        />
      )}
      <div
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        {steps === 0 && (
          <div
            style={{
              height: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                marginTop: '20px',
                width: '100%',
                padding: '0px 30px',
              }}
            >
              <p
                style={{
                  width: '100%',
                  color: '#fff',
                  fontSize: '14px',
                  margin: '30px 0 10px',
                }}
              >
                {newObj.FertilizerTrackingWord[language]}
              </p>

              <p
                style={{
                  width: '100%',
                  color: '#fff',
                  fontSize: '14px',
                  opacity: '0.75',
                  marginBottom: '40px',
                }}
              >
                {newObj.FertilizerTrackingDropzone[language]}
              </p>

              <button
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: 'none',
                  color: 'white',
                  marginTop: '10px',
                  cursor: 'pointer',
                  background: '#5076ee',
                }}
                onClick={() => {
                  setPayload((prev) => ({...prev, type: 'sawit'}));
                  setSteps(1);
                }}
              >
                {newObj.SawitWord[language]}
              </button>
              <button
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '5px',
                  border: 'none',
                  color: 'white',
                  marginTop: '10px',
                  cursor: 'pointer',
                  background: '#5076ee',
                }}
                onClick={() => {
                  setPayload((prev) => ({...prev, type: 'getah'}));
                  setSteps(1);
                }}
              >
                {newObj.GetahWord[language]}
              </button>
            </div>
          </div>
        )}
        {steps === 1 && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%',
              gap: '20px',
              cursor: 'pointer',
            }}
          >
            <div>
              <img src={DragNDrop} alt='drag' style={{width: '200px'}} />
            </div>
            <p
              style={{
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              {!isDragActive &&
                newObj.DragdropsomefileshereorclicktoselectfilesWord[language]}
              {isDragActive && !isDragReject && newObj.DropHereWord[language]}
              {isDragReject && `File type not accepted, sorry!`}
            </p>
          </div>
        )}
        {steps === 2 && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                flexDirection: 'column',
              }}
            >
              <p
                style={{
                  color: 'white',
                  textAlign: 'center',
                }}
              >
                {uploadStatus}
              </p>
              <LinearProgress
                variant='determinate'
                value={progress}
                sx={{
                  height: '10px',
                  width: '100%',
                  marginTop: '10px',
                }}
              />
            </div>
          </div>
        )}
        {steps === 3 && (
          <div
            style={{
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '15px',
            }}
          >
            <div
              style={{
                // margin: "50px 0",
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <CheckCircleOutlineIcon
                style={{color: 'lightgreen', fontSize: '100px'}}
              />
              {newObj.FileUploadedSuccessfully[language]}
            </div>

            <Link to='/pengesyoran-baja' style={{width: '100%'}}>
              <button
                style={{
                  color: 'black',
                  backgroundColor: 'white',
                  border: '1px solid white',
                  padding: '15px',
                  width: '100%',
                  borderRadius: '10px',
                  cursor: 'pointer',
                }}
              >
                {newObj.FertilizerTrackingWord[language]}
              </button>
            </Link>

            <Link to='/adminpage'>
              <div
                style={{
                  color: 'white',
                  textUnderlineOffset: '2px',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
              >
                {newObj.ReturnToTheAdministratorPageWord[language]}
              </div>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
